import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/spaces')({
  beforeLoad: () => {
    throw redirect({
      to: '/dashboard',
      replace: true,
    })
  },
})
